









import Input from '@/components/inputs/Input.vue'
import MoneyHelper from '@/utils/MoneyHelper'
import Component from 'vue-class-component'
import Vue from 'vue'
import { Watch } from 'vue-property-decorator'

export const moneyDirective = Vue.directive('money', (el: any, binding: any) => {
  const defaults = {
    prefix: '',
    suffix: '',
    thousands: ',',
    decimal: '.',
    precision: 2
  }
  if (!binding.value) return
  let opt = MoneyHelper.assign(defaults, binding.value)

  // v-money used on a component that's not a input
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    let els = el.getElementsByTagName('input')
    if (els.length !== 1) {
      // throw new Error("v-money requires 1 input, found " + els.length)
    } else {
      el = els[0]
    }
  }

  el.oninput = function () {
    // let positionFromEnd = el.value.length - el.selectionEnd
    // el.value = MoneyHelper.format(el.value, opt)
    // positionFromEnd = Math.max(positionFromEnd, opt.suffix.length) // right
    // positionFromEnd = el.value.length - positionFromEnd
    // positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1) // left
    // MoneyHelper.setCursor(el, positionFromEnd)
    // el.dispatchEvent(MoneyHelper.event('change')) // v-model.lazy
    // let res = [...el.value].map((d, i) => (i + 1) % 4 === 0 ? ' ' + d.trim() : d.trim()).join('').trim()
    // el.value = res
  }

  el.onfocus = function () {
    // MoneyHelper.setCursor(el, el.value.length - opt.suffix.length)
  }

  el.oninput()
  // el.dispatchEvent(MoneyHelper.event('input')) // force format after initialization
})

export const moneyMask: object = {
  decimal: '.',
  thousands: ',',
  prefix: '',
  suffix: '',
  precision: 2
}

@Component({
  components: {
    Input
  },
  props: {
    value: {
      type: [Number, String],
      default: 0,
      required: true
    }
  }
})
export default class MoneyInput extends Vue {
  amount: any = '';
  max: number = 999999;
  moneyMask: any = moneyMask;

  @Watch('value', {
    immediate: true
  })
  onChangedValue (newValue: any) {
    // let formatted = MoneyHelper.format(newValue, this.moneyMask)
    let formatted = newValue
    if (formatted !== this.amount) {
      this.amount = formatted
    }
  }
  change (e: any) {
    this.$emit('input', MoneyHelper.unformat(e.target.value, this.moneyMask))
  }
}
